function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M0.5 70.5C0.5 70.7761 0.723858 71 1 71H5.5C5.77614 71 6 70.7761 6 70.5C6 70.2239 5.77614 70 5.5 70H1.5V66C1.5 65.7239 1.27614 65.5 1 65.5C0.723858 65.5 0.5 65.7239 0.5 66V70.5ZM0.659385 1.36603C6.59867 6.89287 13.7295 16.9741 15.807 29.2211C17.879 41.4351 14.9359 55.857 0.646447 70.1464L1.35355 70.8536C15.8641 56.343 18.921 41.5982 16.793 29.0539C14.6705 16.5425 7.40133 6.2738 1.34062 0.633966L0.659385 1.36603Z",
  fill: "white"
});

var SvgCreateArrow = function SvgCreateArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 71,
    viewBox: "0 0 18 71",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/create_arrow.aa000bfa.svg";
export { ForwardRef as ReactComponent };